module.exports = __webpack_public_path__ + "img/empty-20240628.f44708c5.png";